import React from 'react';

export default function Footer() {
  return (
    <footer className="bg-[#1F2B73] text-white/70">
      <div className="container-x py-14 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <div className="bg-white rounded-lg px-3 py-2">
              <img
                src="https://customer-assets-4nw71qhi.emergentagent.net/job_ai-analytics-site/artifacts/sk6qr2y3_ExcellenC%20logo%20May%2017%202025.png"
                alt="ExcellenC"
                className="h-8 w-auto"
              />
            </div>
          </div>
          <p className="mt-6 text-[14px] max-w-md leading-relaxed">
            AI-Powered Business Analytics Professional Program — live instructor-led, real-time industry projects,
            internship experience and structured placement.
          </p>
        </div>
        <div>
          <div className="text-[11px] uppercase tracking-widest font-semibold text-white">Program</div>
          <ul className="mt-4 space-y-2 text-[14px]">
            {['Overview', 'Curriculum', 'Tools', 'Projects', 'Placement', 'Fees'].map((l) => (
              <li key={l}>
                <a href={`#${l.toLowerCase()}`} className="hover:text-white transition">
                  {l}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <div className="text-[11px] uppercase tracking-widest font-semibold text-white">Contact</div>
          <ul className="mt-4 space-y-2 text-[14px]">
            <li>Hyderabad · Bengaluru</li>
            <li>+91 91823 84041</li>
            <li>info@excellenc.in</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-x py-6 text-[12px] flex flex-col md:flex-row items-center justify-between gap-3">
          <div>© {new Date().getFullYear()} ExcellenC. All rights reserved.</div>
          <div className="text-white/50">Powered by Intellectra AI · Academic Partner — Texas Tech University</div>
        </div>
      </div>
    </footer>
  );
}
